import { useNavigate } from "react-router-dom";

export function NotFound() {
  const navigate = useNavigate();
  navigate(`/`);
  return null
}
